import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
  import { ALLOWED_MAX_FILE_SIZE_IN_MB, ALLOWED_PLAYLIST_FILE_EXTENSIONS } from '@/constant/const';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';

  
  const __default__ = {
    name: 'FileDropZone',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    allowMultiple: { type: Boolean, required: true, default: true }
  },
  emits: ["filesSelected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'filesSelected', data: { selectedFiles: File[] }): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { allowMultiple: boolean };

  

  

  const inputRef = ref<HTMLInputElement | null>(null);

  function isValidFile(file: File): boolean {
    return ALLOWED_PLAYLIST_FILE_EXTENSIONS.includes(file.type);
  }

  function handleClick() {
    if (inputRef.value === null) return;
    inputRef.value.click();
  }

  function handleDrop(event: DragEvent) {
    const files = event.dataTransfer?.files;

    if (files && files.length > 0) {
      const validFiles = Array.from(files).filter(isValidFile);
      emit('filesSelected', { selectedFiles: validFiles });
    }
  }

  function handleInputChange(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files.length > 0) {
      const validFiles = Array.from(target.files).filter(isValidFile);
      emit('filesSelected', { selectedFiles: validFiles });
    }
  }

return { __sfc: true,props, emit, inputRef, isValidFile, handleClick, handleDrop, handleInputChange, ALLOWED_MAX_FILE_SIZE_IN_MB, ALLOWED_PLAYLIST_FILE_EXTENSIONS, BaseText }
}

})